import { useTranslation } from "react-i18next";
import { Card, CardContent, Typography, Box, IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { IFlyingCart } from "../../../IFlyingCart";
import { useStyle } from "./style";
import { FlyingCartContent } from "../FlyingCartContent/FlyingCartContent";
import { FlyingCartStepperButton } from "../FlyingCartFooter/FlyingCartStepperButton";
import { IStepRoute } from "@common/StepperRouter";
import { ROUTES } from "@constants";

interface IParams {
    arePricesLoading?: boolean;
    flyingCart: IFlyingCart;
    buttonType?: "button" | "submit";
    nextStep?: IStepRoute;
    onNextClick?(): void;
    isSummaryPage?: boolean;
}

export const FlyingCartDesktop = (props: IParams) => {
    const { t } = useTranslation("cart");
    const { classes } = useStyle({});
    const history = useHistory();

    const { flyingCart, onNextClick, buttonType, nextStep, isSummaryPage, arePricesLoading } = props;

    const handleEditClick = () => {
        history.push(ROUTES.CART_PAGE_URL);
    };

    return (
        <Card className={classes.flyingCartCard} elevation={2}>
            <CardContent className={classes.flyingCartContent}>
                <Box className={classes.flyingCartHeader}>
                    <Typography className={classes.flyingCartTitle} variant="h3">
                        {isSummaryPage ? t("OrderSummary") : t("yourGoMoOrder")}
                    </Typography>
                    {isSummaryPage && (
                        <IconButton
                            aria-label="Edit cart"
                            className={classes.flyingCartEditButton}
                            onClick={handleEditClick}
                        >
                            <EditIcon />
                        </IconButton>
                    )}
                </Box>
                <FlyingCartContent arePricesLoading={arePricesLoading} flyingCart={flyingCart} />
                {onNextClick && (
                    <FlyingCartStepperButton buttonType={buttonType} nextStep={nextStep} onNextClick={onNextClick} />
                )}
            </CardContent>
        </Card>
    );
};
